var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-empty',{attrs:{"description":"出错了，请关闭后再打开"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }